import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { disconnectSessions } from '../actions/session';
import {
  idleTimeout, markActivity, MINUTE, waitForPeriodOfInactivity,
} from '../helpers/activityMonitor';

/**
 * Monitors user activity with an event listener and sets the idle state.
 *
 * @returns {Object} - An object containing the extendActivity function and the isIdle state.
 */
const useActivityMonitor = () => {
  const [isIdle, setIsIdle] = useState(false);
  const dispatch = useDispatch();

  const warnAfterIdlePeriod = () => {
    const idleWarningTime = idleTimeout - MINUTE;

    waitForPeriodOfInactivity(idleWarningTime).then(() => {
      setIsIdle(true);
    });
  };

  const extendActivity = () => {
    setIsIdle(false);
    warnAfterIdlePeriod();
  };

  const logoutAfterIdle = () => {
    waitForPeriodOfInactivity(idleTimeout).then(() => {
      dispatch(disconnectSessions());
    });
  };

  useEffect(() => {
    ['keydown', 'mousedown', 'touchstart'].forEach((eventName) => {
      window.addEventListener(eventName, markActivity, { passive: true });
    });

    warnAfterIdlePeriod();
    logoutAfterIdle();

    return () => {
      ['keydown', 'mousedown', 'touchstart'].forEach((eventName) => {
        if (window) {
          window.removeEventListener(eventName, markActivity);
        }
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { extendActivity, isIdle };
};

export default useActivityMonitor;
